import { CALL_API } from 'redux-api-middleware'
import { post, changeSem } from 'utils/network'

export const changeSemester = (payload) => {
  const request = changeSem(payload)
  request.types = ['_REQ', 'AUTH_REFRESH', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const fetchSession = () => {
  const request = post('/session', {})
  request.types = ['_REQ', 'SESSION_CHANGE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/components/ChangeSemester/actions.js